import { useNavigate } from "react-router-dom"
import { useAuth } from "@/modules/Auth/context/AuthContext"
import { useToast } from "@/contexts/ToastContext"
import { Button } from "@/components/ui/button"

export function ImpersonationBanner() {
  const { user, isImpersonating, endImpersonationSession } = useAuth()
  const navigate = useNavigate()
  const toast = useToast()

  if (!isImpersonating) return null

  const handleEnd = async () => {
    await endImpersonationSession()
    toast.success("Personificação encerrada")
    navigate("/personificacao")
  }

  return (
    <div className="sticky top-0 z-50 flex w-full items-center justify-center gap-3 bg-orange-500 px-4 py-2 text-sm font-semibold text-black">
      <i className="fi fi-ts-user-secret flex items-center" />
      <span>
        Você está personificando <strong>{user?.pesNome}</strong>
      </span>
      <Button
        variant="outline"
        size="sm"
        className="h-7 border-black/30 bg-transparent px-3 text-black hover:bg-black/10"
        onClick={handleEnd}
      >
        Encerrar
      </Button>
    </div>
  )
}
